module.exports = __webpack_public_path__ + "mo/img/piece-04.7ba36c55.svg";